import { render, staticRenderFns } from "./ProductAttributeButtonGrid.vue?vue&type=template&id=9dfe1850&scoped=true&"
import script from "./ProductAttributeButtonGrid.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeButtonGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributeButtonGrid.vue?vue&type=style&index=0&id=9dfe1850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfe1850",
  null
  
)

export default component.exports